export class Donation {
    id: number;
    amount: number;
    description: string;
    note: string;
}
